// VAT (Umsatzsteuer) rules for short-term rental
// Source: research/data/vatShortTermRental.json

export const vatRates = {
  accommodation: 0.07,       // 7% ermäßigter Steuersatz for overnight stays
  additionalServices: 0.19,  // 19% for breakfast, parking, etc.
  inputVAT: 0.19,           // 19% recoverable on renovation, services, etc.
};

export const kleinunternehmerThreshold = 25000; // EUR gross annual revenue (since 2025)

export const gewerbesteuerShortTermRules = {
  // Short-term rental with hotel-like services triggers GewSt for private entities
  privateFreibetrag: 24500,  // €24,500 GewSt Freibetrag for natural persons
  anrechnungFaktor: 4.0,    // §35 EStG: GewSt partially creditable against ESt
  triggers: [
    'Hotel-like services (daily cleaning, reception, breakfast)',
    'Multiple Ferienwohnungen operated as business',
    'High frequency guest turnover with organized services',
  ],
  safeHarbor: [
    'Single Ferienwohnung without hotel-like services',
    'Only accommodation + standard turnover cleaning',
  ],
};

// Impact on entity types
export const vatEntityImpact = {
  gmbh: 'Already subject to GewSt — no additional impact from short-term rental',
  immo_gmbh: 'DANGER: Short-term rental likely destroys erweiterte Kürzung (§9 Nr. 1 S. 2 GewStG)',
  gmbh_co_kg: 'Risk of gewerbliche Prägung — may convert to gewerbliche Personengesellschaft',
};
